module.exports = __webpack_public_path__ + "26d0337e1a446430218173bbcf92373a.svg";